import React, { useEffect, useRef, useState } from "react";
import img from "../../assets/HCLTech.jpg";
import "./experience.css";
import { scrolldownani } from "../../animationGsap/Animation";

const formatDuration = (startDate, endDate = new Date()) => {
  const [startYear, startMonth] = startDate.split("-").map(Number);
  const months =
    (endDate.getFullYear() - startYear) * 12 +
    endDate.getMonth() -
    (startMonth - 1) +
    1;
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  const duration = [];

  if (years > 0) {
    duration.push(`${years} yr${years === 1 ? "" : "s"}`);
  }

  if (remainingMonths > 0) {
    duration.push(`${remainingMonths} mo${remainingMonths === 1 ? "" : "s"}`);
  }

  return duration.join(" ");
};

const Experience = () => {
  const expanimation = useRef(null);
  const [isFullTimeExpanded, setIsFullTimeExpanded] = useState(false);
  const [tenure, setTenure] = useState(() => formatDuration("2025-07"));
  const [currentRoleTenure, setCurrentRoleTenure] = useState(() =>
    formatDuration("2025-11")
  );

  useEffect(() => {
    if (expanimation.current) {
      scrolldownani(expanimation.current);
    }

    const updateTenure = () => {
      setTenure(formatDuration("2025-07"));
      setCurrentRoleTenure(formatDuration("2025-11"));
    };

    updateTenure();

    const interval = setInterval(updateTenure, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="experience" ref={expanimation} aria-labelledby="experience-title">
      <h3 id="experience-title">Experience :</h3>
      <div className="experienceInfo">
        <div className="experienceCompany">
          <img className="experienceLogo" src={img} alt="HCLTech logo" />
          <div className="experienceCompanyDetails">
            <h4>HCLTech</h4>
            <p>{tenure}</p>
            <p>Chennai, Tamil Nadu, India · On-site</p>
          </div>
        </div>

        <div className="experienceTimeline">
          <article className="experienceRole">
            <span className="experienceTimelineMarker" aria-hidden="true" />
            <div className="experienceRoleHeading">
              <h5>Graduate Engineering Trainee</h5>
              <p className="experienceRoleType">Full-time</p>
              <p className="experienceRoleDates">
                Nov 2025 - Present · {currentRoleTenure}
              </p>
              <p className="experienceRoleLocation">Chennai, Tamil Nadu, India · On-site</p>
            </div>
            <p className="experienceRoleSummary">
              Contributing to enterprise banking applications, focusing on customer
              onboarding, application journeys, customer engagement, and scoring
              workflows. Focused on reliable backend services, maintainable
              microservices, and seamless feature delivery through effective
              cross-team collaboration.
            </p>
            <button
              className="experienceReadMore"
              type="button"
              aria-expanded={isFullTimeExpanded}
              aria-controls="full-time-experience-details"
              onClick={() => setIsFullTimeExpanded((expanded) => !expanded)}
            >
              {isFullTimeExpanded ? "Show less" : "Read more"}
            </button>
            <div
              id="full-time-experience-details"
              className="experienceExpandedDetails"
              hidden={!isFullTimeExpanded}
            >
              <h6 className="experienceResponsibilitiesTitle">
                Primary Responsibilities &amp; Impact:
              </h6>
              <ol className="experienceResponsibilities">
                <li>
                  <strong>Backend Development:</strong> Maintain Java-based
                  microservices through Java, Spring Boot, and dependency upgrades,
                  supporting service maintainability and compatibility.
                </li>
                <li>
                  <strong>Feature Delivery:</strong> Implement backend features for
                  customer onboarding and application workflows, supporting
                  end-to-end feature delivery.
                </li>
                <li>
                  <strong>Cross-Team Collaboration:</strong> Coordinate API
                  contracts and backend changes with web and mobile teams to
                  minimize integration issues and frontend regressions.
                </li>
                <li>
                  <strong>Bug Resolution:</strong> Investigate and resolve
                  application issues to improve service reliability and reduce
                  recurring defects.
                </li>
                <li>
                  <strong>Deployment Support:</strong> Execute CI/CD pipelines and
                  troubleshoot Kubernetes pods using status checks and log
                  analysis to support efficient issue diagnosis.
                </li>
              </ol>
              <div className="experienceSkills" aria-label="Skills">
                <span>Spring Boot</span>
                <span>Java</span>
                <span>SQL</span>
                <span>Git</span>
                <span>Kubernetes</span>
                <span>Elastic Stack (ELK)</span>
                <span>Microservices</span>
                <span>Apache Kafka</span>
                <span>Amazon DynamoDB</span>
                <span>MariaDB</span>
                <span>Continuous Integration and Continuous Delivery (CI/CD)</span>
                <span>Jenkins</span>
              </div>
            </div>
          </article>

          <article className="experienceRole">
            <span className="experienceTimelineMarker" aria-hidden="true" />
            <div className="experienceRoleHeading">
              <h5>Scholar</h5>
              <p className="experienceRoleType">Internship</p>
              <p className="experienceRoleDates">Jul 2025 - Oct 2025 · 4 mos</p>
              <p className="experienceRoleLocation">Chennai, Tamil Nadu, India</p>
            </div>
            <p className="experienceRoleSummary">
              Completed technical training and foundational development work in
              Java and Spring Boot, building knowledge of backend application
              development, REST APIs, databases, and software engineering
              practices.
            </p>
            <div className="experienceSkills" aria-label="Skills">
              <span>Spring Boot</span>
              <span>Java</span>
              <span>SQL</span>
              <span>Git</span>
              <span>Kubernetes</span>
              <span>JavaScript</span>
              <span>MongoDB</span>
              <span>React.js</span>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Experience;
